import React from 'react';
import { CustomCursor } from './components/CustomCursor';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Portfolio } from './components/Portfolio';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
function App() {
  return <div className="relative bg-background min-h-screen text-ivory selection:bg-gold selection:text-background" data-id="element-0">
      {/* Global Noise Overlay */}
      <div className="noise-overlay" data-id="element-1"></div>

      {/* Custom Cursor */}
      <div className="hidden md:block" data-id="element-2">
        <CustomCursor data-id="element-3" />
      </div>

      <Navbar data-id="element-4" />

      <main data-id="element-5">
        <Hero data-id="element-6" />
        <About data-id="element-7" />
        <Services data-id="element-8" />
        <Portfolio data-id="element-9" />
        <Stats data-id="element-10" />
        <Testimonials data-id="element-11" />
        <Contact data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}
export { App };